// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-page {
  max-width: 1400px;
  margin: 0 auto;
}

.history-page h1 {
  margin-bottom: 30px;
  color: #333;
}

.history-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.history-section,
.status-section,
.totals-section {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.history-section h2,
.status-section h2,
.totals-section h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 18px;
}

.activity-table {
  width: 100%;
  border-collapse: collapse;
}

.activity-table th {
  background: #f5f5f5;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #ddd;
  font-size: 14px;
}

.activity-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 5px;
}

.status-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.status-card {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 5px;
}

.status-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.status-value {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.status-value.in-progress {
  color: #1976d2;
}

.status-value.completed {
  color: #2e7d32;
}

.status-value.error {
  color: #d32f2f;
}

.totals-card {
  text-align: center;
  padding: 20px;
}

.totals-value {
  font-size: 36px;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 10px;
}

.totals-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.totals-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: #333;
}

.historical-reports-section {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.historical-reports-section h2 {
  margin-bottom: 20px;
  color: #333;
}

.reports-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.report-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}

.report-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.report-info h3 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #333;
}

.report-info p {
  font-size: 12px;
  color: #666;
}

.report-thumbnail {
  font-size: 32px;
}

.report-actions {
  display: flex;
  gap: 10px;
}

.btn-small {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 12px;
}

.btn-small.btn-primary {
  background: #1976d2;
  color: white;
  border-color: #1976d2;
}

.loading, .no-data {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* Error status with tooltip */
.status-error-with-tooltip {
  cursor: help;
  border-bottom: 1px dotted #d32f2f;
  position: relative;
}

.status-error-with-tooltip:hover::before,
.status-error-with-tooltip:hover::after {
  opacity: 1;
}

`, "",{"version":3,"sources":["webpack://./src/pages/History.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ","sourcesContent":[".history-page {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.history-page h1 {\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.history-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.history-section,\n.status-section,\n.totals-section {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.history-section h2,\n.status-section h2,\n.totals-section h2 {\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 18px;\n}\n\n.activity-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.activity-table th {\n  background: #f5f5f5;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #ddd;\n  font-size: 14px;\n}\n\n.activity-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n}\n\n.status-cell {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.status-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.status-card {\n  padding: 15px;\n  background: #f9f9f9;\n  border-radius: 5px;\n}\n\n.status-label {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.status-value {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n}\n\n.status-value.in-progress {\n  color: #1976d2;\n}\n\n.status-value.completed {\n  color: #2e7d32;\n}\n\n.status-value.error {\n  color: #d32f2f;\n}\n\n.totals-card {\n  text-align: center;\n  padding: 20px;\n}\n\n.totals-value {\n  font-size: 36px;\n  font-weight: 700;\n  color: #1976d2;\n  margin-bottom: 10px;\n}\n\n.totals-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.totals-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  color: #333;\n}\n\n.historical-reports-section {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.historical-reports-section h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.reports-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.report-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n}\n\n.report-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.report-info h3 {\n  font-size: 16px;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.report-info p {\n  font-size: 12px;\n  color: #666;\n}\n\n.report-thumbnail {\n  font-size: 32px;\n}\n\n.report-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-small.btn-primary {\n  background: #1976d2;\n  color: white;\n  border-color: #1976d2;\n}\n\n.loading, .no-data {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n/* Error status with tooltip */\n.status-error-with-tooltip {\n  cursor: help;\n  border-bottom: 1px dotted #d32f2f;\n  position: relative;\n}\n\n.status-error-with-tooltip:hover::before,\n.status-error-with-tooltip:hover::after {\n  opacity: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
